import { b2x } from '@b2x/react/src';

import { ThankYouPageContentType } from '../contentTypes';
import { t } from '../i18n/i18n';
import { customerIsEmployee, customerIsVet } from '../util';
import { MessageBoxPage } from './MessageBoxPage';

export interface ThankYouPageProps {}

export const ThankYouPage = (props: ThankYouPageProps) => {
  const content = b2x.useContent<ThankYouPageContentType>('THANKYOU_PAGE_CONTENT');

  const { bankAccountDetails, order, session } = b2x.useThankYouPage({});

  return (
    <MessageBoxPage alignItems="align-items-center" img={content?.body.img} justifyContent="justify-content-end">
      <div>
        <h2 className="h3 fw-semi-bold py-1"> {b2x.formatHtml(content?.body.title)}</h2>
        <p className="py-1"> {b2x.formatHtml(content?.body.subTitle)}</p>
        {order?.paymentMethod?.type === 'BANK_TRANSFER' ? (
          <>
            <div className="small fw-light">{b2x.formatHtml(content?.body.bankTransfer?.pre)}</div>
            <dl className="row small fw-light">
              <dt className="col-6 fw-medium text-uppercase text-end">{t('misc.amount')}</dt>
              <dd className="col-6 text-start">{b2x.formatCurrency(order.totalCost)}</dd>
              <dt className="col-6 fw-medium text-uppercase text-end">{t('bankAccountDetails.ownerName')}</dt>
              <dd className="col-6 text-start">{bankAccountDetails?.ownerName}</dd>
              <dt className="col-6 fw-medium text-uppercase text-end">{t('bankAccountDetails.bankName')}</dt>
              <dd className="col-6 text-start">{bankAccountDetails?.bankName}</dd>
              <dt className="col-6 fw-medium text-uppercase text-end">{t('bankAccountDetails.ibanCode')}</dt>
              <dd className="col-6 text-start">{bankAccountDetails?.ibanCode}</dd>
              <dt className="col-6 fw-medium text-uppercase text-end">{t('bankAccountDetails.bicSwiftCode')}</dt>
              <dd className="col-6 text-start">{bankAccountDetails?.bicSwiftCode}</dd>
            </dl>
            <div className="small fw-light">{b2x.formatHtml(content?.body.bankTransfer?.post)}</div>
          </>
        ) : (
          <div className="small fw-light px-3">
            {order?.paymentMethod?.type === 'CASH_ON_DELIVERY' && (
              <>
                <div className="my-3">{b2x.formatHtml(content?.body.cashOnDelivery)}</div>
                <div className="my-3">
                  {t('checkout.thankYou.cashOnDelivery.amountToPayOnDelivery')}:{' '}
                  <strong>{b2x.formatCurrency(order.totalCost)}</strong>
                </div>
              </>
            )}
            {b2x.formatHtml(order?.virtual ? content?.body.contentForVirtualOrder : content?.body.content)}
          </div>
        )}
        <h6 className="mb-4 mt-5">
          {t('misc.orderCode')}: {order?.code}
        </h6>
      </div>
      {session?.userLogged &&
        session.customer?.qualifiers &&
        !customerIsVet(session.customer.qualifiers) &&
        !customerIsEmployee(session.customer.qualifiers) &&
        (session.customer.newsletterConsent
          ? content?.body.cta && (
              <b2x.DeprecatedCta className="btn btn-primary mb-4" cta={content.body.cta}>
                {b2x.formatHtml(content.body.cta.label)}
              </b2x.DeprecatedCta>
            )
          : content?.body.newsletterSection?.content &&
            content.body.newsletterSection.cta && (
              <div className="bg-gray-200 p-3 mx-n3 mb-n3 mx-lg-n4 mb-lg-n4">
                <h6 className="mb-4">{b2x.formatHtml(content.body.newsletterSection.content)}</h6>
                <div className="d-flex justify-content-around">
                  <b2x.DeprecatedCta className="btn btn-primary" cta={content.body.newsletterSection.cta}>
                    {b2x.formatHtml(content.body.newsletterSection.cta.label)}
                  </b2x.DeprecatedCta>
                </div>
              </div>
            ))}
      {!session?.userLogged && (
        <div className="bg-gray-200 p-3 mx-n3 mb-n3 mx-lg-n4 mb-lg-n4">
          <h6 className="mb-4">{b2x.formatHtml(content?.body.registerSection?.content)}</h6>
          <div className="d-flex justify-content-around">
            {content?.body.registerSection?.ctaContinue && (
              <b2x.DeprecatedCta className="btn btn-primary" cta={content.body.registerSection.ctaContinue}>
                {b2x.formatHtml(content.body.registerSection.ctaContinue.label)}
              </b2x.DeprecatedCta>
            )}
            {content?.body.registerSection?.ctaCancel && (
              <b2x.DeprecatedCta className="btn btn-outline-primary" cta={content.body.registerSection.ctaCancel}>
                {b2x.formatHtml(content.body.registerSection.ctaCancel.label)}
              </b2x.DeprecatedCta>
            )}
          </div>
        </div>
      )}
    </MessageBoxPage>
  );
};
